<form
        [formGroup]="userSubRegionSelectionForm"
        class="dropdown__container"
        autocomplete="off">
    <p-dropdown
            *ngIf="addUserSubRegionEnabled"
            class="dropdown__primary"
            formControlName="userSubRegionId"
            appendTo="body"
            placeholder="Select a sub-region"
            [options]="userSubRegions"
            optionLabel="name"
            optionValue="id"
            [loading]="loading"
            [disabled]="loading"
            (onChange)="userSubRegionChanged($event)">
    </p-dropdown>
</form>
